module.exports = __webpack_public_path__ + "img/Delete - Dark Gray - Selected.114ac1b5.png";